import React from 'react'

import {
  RewardProgramDetailsDto,
  RewardProgramDetailsTierDto,
  RewardProgramEligibilityCheckDto,
} from '@pages/RewardsHub/RewardHubDto'
import { useRewardProgramTierProgress } from '@pages/RewardsHub/hooks/useRewardProgramTierProgress'

import { Caption1 } from '@ui/Typography'
import { ProgressBar } from '@ui/components/ProgressBar'

import { getCurrencySymbol } from '@utils/transaction.utils'

import { CurrencyType } from '@model/WalletDto'

import { Box } from '@shared/components/Box'

interface RewardProgramTierProgressBarsProps {
  rewardProgramTier?: RewardProgramDetailsTierDto[]
  progress?: RewardProgramEligibilityCheckDto
  claimableTierIndex?: number
  rewardProgram?: RewardProgramDetailsDto
  isExpanded: boolean
}

export const RewardProgramTierProgressBars: React.FC<RewardProgramTierProgressBarsProps> = (
  props: RewardProgramTierProgressBarsProps
) => {
  const { shouldRender, tiersData } = useRewardProgramTierProgress(props)

  if (!shouldRender) {
    return null
  }

  const trackingMetricName = props.rewardProgramTier?.[0]?.trackingMetric?.name

  return (
    <Box flex direction='column' gap='x4'>
      {trackingMetricName && (
        <Box flex fullWidth>
          <Caption1 semibold color='text-high-em'>
            {trackingMetricName}
          </Caption1>
        </Box>
      )}

      <Box flex fullWidth direction='row' gap='x8'>
        {tiersData.map((tier) => {
          const visibleBars = tier.bars.filter((_, barIndex) => props.isExpanded || barIndex === 0)

          return (
            <Box key={tier.id} flex direction='column' gap='x24' flexItem='1' minWidth={0}>
              {visibleBars.map((bar, barIndex) => {
                const showCurrency = bar.showCurrencySymbol
                const fullValueText = `${
                  showCurrency ? getCurrencySymbol(bar.currency?.id as CurrencyType) : ''
                }${bar.valueLabel}`

                return (
                  <Box key={bar.id} flex direction='column' gap='x4'>
                    {barIndex > 0 && (
                      <Caption1 semibold color='text-high-em'>
                        {bar.label}
                      </Caption1>
                    )}
                    <Caption1 key={tier.id} semibold color='text-med-em'>
                      {tier.name}
                    </Caption1>
                    <ProgressBar color={bar.barColor} percent={bar.barPercent} />
                    <Caption1 color='text-med-em'>{fullValueText}</Caption1>
                  </Box>
                )
              })}
            </Box>
          )
        })}
      </Box>
    </Box>
  )
}
